import React from 'react';
import brickAnimation from '../../assets/brick_animation.gif';
import { FormattedMessage } from 'react-intl';

interface BrickAnimationProps {
  messageKey?: string;
}

export const BrickAnimation: React.FC<BrickAnimationProps> = ({ messageKey }) => {
  return (
    <div
      style={{
        flex: 1,
        padding: '16px 16px',
      }}
    >
      <div
        style={{
          marginTop: '32px',
          marginBottom: '32px',
        }}
      >
        <span data-testid="brick-animation-title" className="titleMedium">
          <FormattedMessage id={messageKey || 'brick_animation.title'} />
        </span>
      </div>
      <img src={brickAnimation} />
    </div>
  );
};
